<template>
  <div>
    <div :class="'header finish-' + finish">
      <div
        v-for="(item, index) in menuData"
        :key="index"
        :class="'menu-link menu-link-' + item.Step + (item.Step == current ? ' active' : '')"
        @click="toStep(item.Step)"
      >
        <img class="img" :src="item.Step == current ? item.ImgUrlActive : item.ImgUrl" />
      </div>
    </div>
  </div>
</template>

<script>
import { behavior } from '@/utils/behavior'
export default {
  props: {
    current: [String, Number],
    finish: [String, Number],
  },
  data() {
    return {
      menuData: [
        {
          Step: 1,
          ImgUrl: require('@static/funding_cpunk/creation/menu-1.png'),
          ImgUrlActive: require('@static/funding_cpunk/creation/menu-1-active.png'),
        },
        {
          Step: 2,
          ImgUrl: require('@static/funding_cpunk/creation/menu-2.png'),
          ImgUrlActive: require('@static/funding_cpunk/creation/menu-2-active.png'),
        },
        {
          Step: 3,
          ImgUrl: require('@static/funding_cpunk/creation/menu-3.png'),
          ImgUrlActive: require('@static/funding_cpunk/creation/menu-3-active.png'),
        },
      ],
    }
  },
  methods: {
    toStep(step) {
      const { current, finish } = this
      if (step == current || step > finish) return
      if (step == 1) {
        _jcq.push(['_track', 'yjhbccoverbar_click'])
        behavior({ behavior_code: 'prc_bhv_abs_bcyjh_bc21' })
      } else if (step == 2) {
        _jcq.push(['_track', 'yjhbcinfobar_click'])
        behavior({ behavior_code: 'prc_bhv_abs_bcyjh_bc22' })
      } else if (step == 3) {
        _jcq.push(['_track', 'yjhbcmessagebar_click'])
        behavior({ behavior_code: 'prc_bhv_abs_bcyjh_bc23' })
      }
      this.$router.push({ path: `/fundingnew/creation/step${step}`, query: this.$route.query })
    },
  },
}
</script>

<style lang="scss" scoped>
.header {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  width: 100%;
  height: pxtow(115);
  z-index: 3;
  background: #10104e;
}
.header .menu-link {
  flex: 1;
}
.header .menu-link .img {
  width: 100%;
  height: auto;
}
.finish-0 .menu-link {
  opacity: 0.5;
}
.finish-0 .active {
  opacity: 1;
}
.finish-1 .menu-link {
  opacity: 0.5;
}
.finish-1 .active,
.finish-1 .menu-link-1 {
  opacity: 1;
}
.finish-2 .menu-link {
  opacity: 0.5;
}
.finish-2 .active,
.finish-2 .menu-link-1,
.finish-2 .menu-link-2 {
  opacity: 1;
}
.finish-3 .menu-link {
  opacity: 0.5;
}
.finish-3 .active,
.finish-3 .menu-link-1,
.finish-3 .menu-link-2,
.finish-3 .menu-link-3 {
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/pages/fundingnew/components/Menu.vue